import React from 'react';
import './StorePickupInfo.css';

const StorePickupInfo = ({ store }) => {
  if (!store) return null;

  return (
    <div className="store-pickup-info">
      <h3> Informacion de Pickup </h3>
      
      <div className="store-details">
        <div className="store-header">
          <span className="store-icon">📍</span>
          <span className="store-name">{store.name}</span>
        </div>
        
        <p className="store-address">{store.address}</p>
        
        <div className="pickup-time">
          <span className="time-icon">🕒</span>
          <span className="time-text">Listo en 10-15 minutos</span>
        </div>
        
        <div className="store-hours">
          <strong>Horas:</strong>
          {store.hours.split('\n').map((line, index) => (
            <p key={index} className="hour-line">{line}</p>
          ))}
        </div>
      </div>
      
      <button className="change-store-btn">
        Cambiar de tienda
      </button>
    </div>
  );
};

export default StorePickupInfo;